<template>
  <article class="singleMain">
    <header class="singleMain--header">
      <div class="singleMain--headerImg">
        <ImgClean
        :imgFull='imgFull'
        :imgLarge='imgLarge'
        :imgMedium='imgMedium'
        :imgSmall='imgSmall'/>
      </div>

      <div class="singleMain--headerTitle">
        <h1 class="titleArticle">
          {{ title }}
        </h1>
      </div>
    </header>

    <div class="singleMain--content">
      <div class="singleMain--contentText" v-html="text">
      </div>
    </div>
  </article>
</template>

<script>
import ImgClean from '@/components/_ImgClean'

export default {
  name: 'SingleMain',
  components: {
    ImgClean
  },
  props: {
    imgFull: {
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgLarge: {
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgMedium: {
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgSmall: {
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    alt: {
      default: 'alt singleMain'
    },
    title: {
      default: 'title singleMain'
    },
    text: {
      default: 'text singleMain'
    }
  }
}
</script>

<style>

</style>
